module.exports = __webpack_public_path__ + "static/Pt43-removebg-preview-8fd5eb28e130338f4b9f3fea7e39b6cf.png";